import type { OrganizationTreeWrapperProps } from "./organization-tree.type";

import OrganizationTree from "./organization-tree.component";

const OrganizationTreeWrapper = ({
  organizationId,
  ...options
}: OrganizationTreeWrapperProps) => {
  if (!organizationId) return null;

  return <OrganizationTree organizationId={organizationId} {...options} />;
};

export default OrganizationTreeWrapper;
